import React, { useState, useEffect, useCallback } from 'react';
import api from '../api';
import { messageErreur, dateCourte } from './commun';

const ROLES = [
  { cle: 'commercial', libelle: 'Commercial / assistante', aide: 'Saisit et consulte les comptes de sa société.' },
  { cle: 'direction', libelle: 'Direction', aide: 'Comme un commercial, sans administration. Sans société : voit les deux.' },
  { cle: 'admin', libelle: 'Administrateur', aide: 'Tout, dont cette page et la suppression de comptes.' },
];

export default function Utilisateurs({ utilisateur, referentiel }) {
  const [liste, setListe] = useState([]);
  const [erreur, setErreur] = useState('');
  const [f, setF] = useState({ identifiant: '', nom: '', role: 'commercial', societe_id: '', mot_de_passe: '' });
  const [info, setInfo] = useState('');

  const charger = useCallback(async () => {
    try { setListe((await api.get('/utilisateurs')).data.utilisateurs); } catch (e) { setErreur(messageErreur(e)); }
  }, []);
  useEffect(() => { charger(); }, [charger]);

  const creer = async (e) => {
    e.preventDefault(); setErreur(''); setInfo('');
    try {
      await api.post('/utilisateurs', { ...f, societe_id: f.societe_id || null });
      setInfo(`Compte « ${f.identifiant} » créé. Transmettez le mot de passe de vive voix, pas par e-mail : il devra être changé à la première connexion.`);
      setF({ identifiant: '', nom: '', role: 'commercial', societe_id: '', mot_de_passe: '' }); charger();
    } catch (err) { setErreur(messageErreur(err)); }
  };
  const modifier = async (u, champs) => {
    setErreur(''); setInfo('');
    try { await api.patch(`/utilisateurs/${u.id}`, champs); charger(); } catch (err) { setErreur(messageErreur(err)); }
  };
  const reinitialiser = async (u) => {
    // Son propre mot de passe se change dans « Mon mot de passe » (l'actuel y est demandé).
    if (u.id === utilisateur.id) { window.location.hash = '#/mot-de-passe'; return; }
    const mdp = window.prompt(`Nouveau mot de passe pour ${u.identifiant} (10 caractères minimum) :`);
    if (mdp) {
      await modifier(u, { mot_de_passe: mdp });
      setInfo(`Mot de passe de ${u.identifiant} changé. Il devra être remplacé à la prochaine connexion.`);
    }
  };

  return (
    <div className="utilisateurs">
      <h1>Utilisateurs</h1>
      <p className="sous-titre">La société fixe ce que chacun voit. Sans société, la personne voit Belle d'Argence et Xavier Vins.</p>
      {erreur && <div className="erreur">{erreur}</div>}
      {info && <div className="bandeau-info">{info}</div>}
      <div className="tableau">
        <table>
          <thead><tr><th>Identifiant</th><th>Nom</th><th>Rôle</th><th>Société</th><th>Dernière connexion</th><th /></tr></thead>
          <tbody>
            {liste.map((u) => (
              <tr key={u.id} className={u.actif ? '' : 'inactif'}>
                <td><strong>{u.identifiant}</strong>{u.mdp_a_changer && <div className="discret">Mot de passe à changer</div>}</td>
                <td><input defaultValue={u.nom || ''} onBlur={(e) => e.target.value !== (u.nom || '') && modifier(u, { nom: e.target.value })} aria-label={`Nom de ${u.identifiant}`} /></td>
                <td>
                  <select value={u.role} onChange={(e) => modifier(u, { role: e.target.value })} aria-label={`Rôle de ${u.identifiant}`}>
                    {ROLES.map((r) => <option key={r.cle} value={r.cle}>{r.libelle}</option>)}
                  </select>
                </td>
                <td>
                  <select value={u.societe_id || ''} onChange={(e) => modifier(u, { societe_id: e.target.value || null })} aria-label={`Société de ${u.identifiant}`}>
                    <option value="">Toutes</option>
                    {referentiel?.societes.map((s) => <option key={s.id} value={s.id}>{s.nom}</option>)}
                  </select>
                </td>
                <td className="discret">{u.derniere_connexion ? dateCourte(u.derniere_connexion) : 'Jamais'}</td>
                <td className="droite">
                  <button type="button" className="lien" onClick={() => reinitialiser(u)}>Mot de passe</button>
                  {u.id !== utilisateur.id && (
                    <button type="button" className="lien" onClick={() => modifier(u, { actif: !u.actif })}>{u.actif ? 'Désactiver' : 'Réactiver'}</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <form className="carte nouvel-utilisateur" onSubmit={creer}>
        <h2>Ajouter une personne</h2>
        <div className="formulaire-grille">
          <label><span>Identifiant de connexion</span><input value={f.identifiant} onChange={(e) => setF({ ...f, identifiant: e.target.value.toLowerCase() })} placeholder="mathieu" required /></label>
          <label><span>Nom affiché</span><input value={f.nom} onChange={(e) => setF({ ...f, nom: e.target.value })} placeholder="Mathieu" /></label>
          <label><span>Rôle</span>
            <select value={f.role} onChange={(e) => setF({ ...f, role: e.target.value })}>{ROLES.map((r) => <option key={r.cle} value={r.cle}>{r.libelle}</option>)}</select>
          </label>
          <label><span>Société</span>
            <select value={f.societe_id} onChange={(e) => setF({ ...f, societe_id: e.target.value })}>
              <option value="">Toutes (direction)</option>
              {referentiel?.societes.map((s) => <option key={s.id} value={s.id}>{s.nom}</option>)}
            </select>
          </label>
          <label><span>Mot de passe initial</span><input type="text" value={f.mot_de_passe} onChange={(e) => setF({ ...f, mot_de_passe: e.target.value })} minLength={10} required autoComplete="new-password" /></label>
        </div>
        <p className="aide">{ROLES.find((r) => r.cle === f.role)?.aide} Mot de passe : 10 caractères minimum.</p>
        <div className="actions"><button type="submit">Créer le compte</button></div>
      </form>
    </div>
  );
}
